/* global globalThis */
/** Bundled deps occasionally reference global `process` in the browser. */
if (typeof process === "undefined") {
  // eslint-disable-next-line no-global-assign
  globalThis.process = { env: {} };
}
